<template>
  <div class="PackagingShell" id="PackagingShell">
    <!--主题内容，展示内容区域-->
    <div id="viewBox">
      <!--文本主体-->
      <span id="marquee">{{ownText}}</span>
      <!--文本副本，实现无缝滚动-->
      <span id="transcript" ></span>
    </div>
    <!--隐藏块，用于获取展示文本宽度-->
    <div id="hide">{{ownText}}</div>
  </div>
</template>

<script>
    export default {
        name: "Marquee",
        props:{
            text:{
                type:String,
                required:true,
                default:'',
            }
        },
        watch:{
            text:function (newProps) {

                this.ownText=newProps

                this.$nextTick(()=>{
                    this.move()
                })
            }
        },

        created() {
            this.ownText=this.text
        },
        data () {
            return {
                translateTimer:-1,
                ownText:'',
                textWidth: 0, // 字符长度
                isScroll: false, // 是否滚动
                copyArr: [],
                Arr: [...new Array(10).fill({text: '测无', ssss: '动无', right: '用于获'}).map((i, index) => {return { text: '测无' + index, ssss: '动无', right: '用于获'}})]
            }
        },
        methods: {

            // 横向滚动
            move () {
                // 首先获取整个内容的宽度,(展示内容会超出隐藏,无法通过获取盒子宽度取到实际的内容宽度)
                // 所以专门造了一个 div 块来放内容,隐藏起来 (无法用根据字体内容来计算宽度的方法,存在误差,当内容较多
                // 的时候误差会相对较大)
                let width = document.getElementById('hide').getBoundingClientRect().width
                // 获取展示块盒模型宽度
                let BoxWidth = document.getElementById('PackagingShell').offsetWidth
                // 获取内容展示宽
                let viewBox = document.getElementById('viewBox')
                // 判断内容是否超长
                // console.log('BoxWidth',BoxWidth)
                // console.log('width',width)

                let distance = 0
                let translateFn=()=> {

                    distance = distance - 1
                    // 判断是否整个内容移动完
                    if (-distance >= width) {
                        // 若移动完,则重新设定位移值,此处赋值200是正好把 上面设置的块间距  200px 也加入移动范围,实现移动完无缝跳转
                        distance = 20
                    }
                    // 实时设置位移距离
                    viewBox.style.transform = 'translateX(' + distance + 'px)'
                }
                if ((BoxWidth - width) < 0) {
                    // 内容超长,则获取抄本元素
                    let transcript = document.getElementById('transcript')
                    // 抄本元素内容填充
                    transcript.innerText = this.ownText
                    // 设定抄本和主题之间的间距
                    transcript.style.marginLeft = '20px'
                    // console.log('执行启动定时器')
                    if (this.translateTimer===-1){
                        let timer = setInterval(translateFn,27)
                        this.translateTimer = timer
                    }
                } else {
                    // return
                    // console.log('停止计时器')
                    let transcript = document.getElementById('transcript')
                    // 抄本元素内容填充
                    transcript.innerText = ''
                    viewBox.style.transform = 'translateX(' + 0 + 'px)'
                    this.translateTimer>-1&&clearInterval(this.translateTimer)

                }


            },

        },
        mounted () {
            // 初始化

            this.move()

        },
        // 更新的时候运动
        updated: function () {

        }
    }
</script>

<style scoped>
  /*公告滚动盒子样式*/
  .PackagingShell {
    width: 37%;        /*滚动部分宽度*/
    overflow: hidden;  /*超出部分隐藏*/
    font-size: 12px;
    color: #FFFFFF;


  }
  /*主题内容块设置*/
  #viewBox {
    /*设置内容框不可换行,确保两个div块始终在同一行*/
    white-space: nowrap;

  }
  /*内容块设置*/
  #marquee {
    /*设置内容块不可换行*/
    white-space: nowrap;
  }
  /*获取宽度的块，用z-index隐藏*/
  #hide {
    position: absolute;
    z-index: -999;
    top: -9999px;
    white-space: nowrap;
  }

</style>
